const AUTH_PATHS = ["/login", "/register", "/forget-password", "/reset", "/accept-invitation"];
const LEGACY_STORAGE_KEY = "lbhq_affiliate_ref";
const RESERVED_REFERRAL_SLUGS = new Set([
  "503",
  "accept-invitation",
  "add-user",
  "affiliate",
  "affiliate-url",
  "billing",
  "brand-mentions",
  "byorder",
  "dashboard",
  "destination",
  "destination-list",
  "digitalpr",
  "domain",
  "domain-detail",
  "draft-order",
  "edited-order-summary",
  "email-verification",
  "enterprise",
  "forget-password",
  "invoice",
  "invoice-payment",
  "invoice-view",
  "invoices",
  "login",
  "media-links",
  "media-links-summary",
  "missed-opportunity",
  "missed-opportunity-order",
  "new-product",
  "open-invoices",
  "order",
  "order-detail",
  "order-opproval-links",
  "order-opprovals",
  "order-receipts",
  "order-summary",
  "packages",
  "product",
  "register",
  "report-order-detail",
  "reset",
  "user-profile",
  "users",
]);
const RESERVED_KEYWORD_MESSAGE = "This keyword is not available. Please choose another one.";

function firstValue(value) {
  if (value == null || value === "") {
    return null;
  }
  const raw = Array.isArray(value) ? value[0] : value;
  const text = String(raw).trim();
  return text || null;
}

function clearPersistedAffiliateRef() {
  try {
    window.localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch (error) {
    // ignore
  }
  try {
    window.sessionStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch (error) {
    // ignore
  }
  try {
    document.cookie = `${LEGACY_STORAGE_KEY}=; path=/; max-age=0`;
    document.cookie = `${LEGACY_STORAGE_KEY}=; path=/; max-age=0; domain=.linkbuildinghq.com`;
  } catch (error) {
    // ignore
  }
}

clearPersistedAffiliateRef();

export function getRefFromUrl() {
  try {
    return firstValue(new URLSearchParams(window.location.search).get("ref"));
  } catch (error) {
    console.warn("Failed to parse affiliate ref from URL", error);
    return null;
  }
}

export function getRefFromQuery(query = {}) {
  return firstValue(query?.ref);
}

export function withRouteRef(routeQuery = {}, extra = {}) {
  const query = { ...routeQuery, ...extra };
  const ref = firstValue(routeQuery.ref);
  if (ref) {
    query.ref = ref;
  }
  return query;
}

export function isAuthPath(path) {
  return AUTH_PATHS.includes(path);
}

export function reservedReferralKeywordMessage() {
  return RESERVED_KEYWORD_MESSAGE;
}

export function isReservedReferralSlug(slug) {
  const key = String(slug || "").trim().toLowerCase();
  return key !== "" && RESERVED_REFERRAL_SLUGS.has(key);
}

export function referralSlugFromValue(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const queryMatch = raw.match(/[?&]ref=([^&]+)/i);
  if (queryMatch) {
    try {
      return decodeURIComponent(queryMatch[1]).trim();
    } catch (error) {
      return String(queryMatch[1] || "").trim();
    }
  }
  try {
    const parsed = new URL(raw, typeof window !== "undefined" ? window.location.origin : "http://localhost");
    const parts = String(parsed.pathname || "")
      .split("/")
      .filter(Boolean);
    return parts[parts.length - 1] || "";
  } catch (error) {
    return raw.replace(/^\/+/, "").split("/")[0];
  }
}

export function shortReferralPath(slug) {
  const code = referralSlugFromValue(slug);
  return code ? `/${code}` : "";
}

export function shortReferralUrl(slug, appUrl = "") {
  const code = referralSlugFromValue(slug);
  if (!code) return "";
  const origin = String(appUrl || (typeof window !== "undefined" ? window.location.origin : ""))
    .replace(/\/$/, "");
  return origin ? `${origin}/${code}` : `/${code}`;
}
